import { getIssuers, Issuer } from '@/services/api/issuer'
import useApi from '@/services/hooks/useApiV2'

const useIssuers = () => {
  const { data, isLoading, isError } = useApi<Issuer[]>({
    key: `issuers`,
    request: () => getIssuers(),
  })

  return {
    issuers: data,
    isLoading,
    isError,
  }
}

export default useIssuers
